import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=5473c7f3&scoped=true&"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5473c7f3",
  null
  
)

export default component.exports